<div class="poe-scroll">
  <div class="readonlytbox milestone-panel">
    @if (programSharedService.checkEventType(EventType.DoMoreWithE3E5)) {
      <div class="ui-g pl-2 pr-4">
        <div class="ui-g-12 ui-md-4 ui-lg-4">M2 Expiration Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            placeholder="mm/dd/yyyy"
            [value]="programSharedService.getMilestone2ExpirationDate()" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }

    @if (hasMilestoneData) {
      <div class="ui-g designation-section pl-2 pr-4">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Identifier</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4 dropdown">
          <p-select
            appendTo="body"
            [options]="eventsMilestone2Details.customers"
            [(ngModel)]="selectedCustomer"
            (onChange)="onCustomerChange()"
            placeholder="--SELECT--"
            optionLabel="customerKey"></p-select>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }

    @if (hasMilestoneData && isMRPPProgram) {
      <div class="ui-g pl-2 pr-4">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payout Metric</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4 dropdown">
          <p-select
            appendTo="body"
            [options]="payoutMetricOptions"
            [(ngModel)]="selectedPayoutMetric"
            (onChange)="onPayoutMetricChange()"
            placeholder="--SELECT--"
            optionLabel="label"></p-select>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }

    @if (hasMilestoneData && isMRPPProgram) {
      <div class="ui-g pl-2 pr-4">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Month</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4 dropdown">
          <p-select
            appendTo="body"
            [options]="months"
            [(ngModel)]="selectedMonth"
            (onChange)="onMonthChange()"
            placeholder="--SELECT--"
            optionLabel="label"></p-select>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }

    @if (hasMilestoneData) {
      <div class="milestone2-tabs">
        <p-tabs scrollable value="0" (onChange)="paymentMetricsTabChange()">
          <p-tablist>
            <p-tab value="0">NPSA E3</p-tab>
            <p-tab value="1">NPSA E5</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              @if (showFormE3Maturity) {
                <form [formGroup]="formE3Maturity">
                  <div class="rtnav ui-g">
                    <div class="ui-g-6 msgbox-6">
                      @for (
                        message of msgsMilestone2InvoiceDetails;
                        track message
                      ) {
                        <p-message
                          [life]="3000"
                          [text]="message.detail"></p-message>
                      }
                    </div>
                    @if (!eventsMilestone2btnNav) {
                      <div class="ui-g-5"></div>
                    }
                    @if (eventsMilestone2btnNav) {
                      <div class="ui-g-5">
                        <button
                          type="button"
                          pButton
                          (click)="editEventsMilestone2Cancel(formE3Maturity)"
                          class="ui-button-secondary flat fl-rt">
                          Cancel
                        </button>
                        <button
                          type="submit"
                          pButton
                          (click)="
                            onSubmiEventstMilestone2Data(
                              formE3Maturity,
                              'NPSA E3'
                            )
                          "
                          class="flat btnmr fl-rt">
                          Save
                        </button>
                      </div>
                    }
                    <div class="ui-g-1 edit-history-icon">
                      <button
                        class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                        pTooltip="Edit"
                        (click)="editEventsMilestone2Data(false)"
                        tooltipPosition="bottom">
                        Edit
                      </button>
                    </div>
                  </div>

                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Key</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="eventPaymentRecordId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Type</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="eventType" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 1</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        [(ngModel)]="selectedCustomer.tenantId"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="tier1PaidDate"
                        placeholder="mm/dd/yy"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1MaturityDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1MaturityStatus" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        [readonly]="isReadonlyMilestone2Payment"
                        pInputText
                        formControlName="tier1PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice Number</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        [readonly]="isReadonlyMilestone2Payment"
                        pInputText
                        formControlName="tier1InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        [readonly]="isReadonlyMilestone2Payment"
                        pInputText
                        formControlName="tier1PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        formControlName="tier1PaymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 2</div>
                    </div>
                  </div>

                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        [(ngModel)]="selectedCustomer.tenantId"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="tier2PaidDate"
                        placeholder="mm/dd/yy"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2MaturityDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2MaturityStatus" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier2PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice Number</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier2InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier2PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        formControlName="tier2PaymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                </form>
              }
              @if (!showFormE3Maturity) {
                <h3>
                  Payment Milestone 2 NPSA E3 metrics data not yet available for
                  the engagement
                </h3>
              }
            </p-tabpanel>
            <p-tabpanel value="1">
              @if (showFormE5Maturity) {
                <form [formGroup]="formE5Maturity">
                  <div class="rtnav ui-g">
                    <div class="ui-g-6 msgbox-6">
                      @for (
                        message of msgsMilestone2InvoiceDetails;
                        track message
                      ) {
                        <p-message
                          [life]="3000"
                          [text]="message.detail"></p-message>
                      }
                    </div>
                    @if (!eventsMilestone2btnNav) {
                      <div class="ui-g-5"></div>
                    }
                    @if (eventsMilestone2btnNav) {
                      <div class="ui-g-5">
                        <button
                          type="button"
                          pButton
                          (click)="editEventsMilestone2Cancel(formE5Maturity)"
                          class="ui-button-secondary flat fl-rt">
                          Cancel
                        </button>
                        <button
                          type="submit"
                          pButton
                          (click)="
                            onSubmiEventstMilestone2Data(
                              formE5Maturity,
                              'NPSA E5'
                            )
                          "
                          class="flat btnmr fl-rt">
                          Save
                        </button>
                      </div>
                    }
                    <div class="ui-g-1 edit-history-icon">
                      <button
                        class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                        pTooltip="Edit"
                        (click)="editEventsMilestone2Data(false)"
                        tooltipPosition="bottom">
                        Edit
                      </button>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Key</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="eventPaymentRecordId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Type</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="eventType" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 1</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        [(ngModel)]="selectedCustomer.tenantId"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="tier1PaidDate"
                        placeholder="mm/dd/yy"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1MaturityDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier1MaturityStatus" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier1PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice Number</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier1InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier1PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        formControlName="tier1PaymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>

                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 2</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        [(ngModel)]="selectedCustomer.tenantId"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="tier2PaidDate"
                        placeholder="mm/dd/yy"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2MaturityDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier2MaturityStatus" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier2PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice Number</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier2InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier2PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        formControlName="tier2PaymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                </form>
              }
              @if (!showFormE5Maturity) {
                <h3>
                  Payment Milestone 2 NPSA E5 metrics data not yet available for
                  the engagement
                </h3>
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>

        @if (isMRPPProgram) {
          <div>
            @if (showFormPaymentDetails) {
              <form [formGroup]="formMRPPMilestone2">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (
                      message of msgsMilestone2InvoiceDetails;
                      track message
                    ) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!eventsMilestone2btnNav) {
                    <div class="ui-g-5"></div>
                  }
                  @if (eventsMilestone2btnNav) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="editEventsMilestone2Cancel(formMRPPMilestone2)"
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="
                          onSubmiEventstMilestone2Data(formMRPPMilestone2, '')
                        "
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <button
                      class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                      pTooltip="Edit"
                      (click)="editEventsMilestone2Data(false)"
                      tooltipPosition="bottom">
                      Edit
                    </button>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="eventType" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="paymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="metDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      [readonlyInput]="true"
                      formControlName="paidDate"
                      placeholder="mm/dd/yy"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="maturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="maturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="paymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice Number</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="invoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="paymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      formControlName="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Growth incremental Licenses/MAD (payout)
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <textarea
                      pTextarea
                      pInputTextarea
                      readonly
                      formControlName="growthPerMAD"
                      rows="2"></textarea>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              </form>
            }
            @if (!showFormPaymentDetails) {
              <h3>
                Payment Milestone 2 {{ selectedMonth?.value }} data not yet
                available for the engagement
              </h3>
            }
          </div>
        }
      </div>
    }
    @if (!hasMilestoneData) {
      <div>
        <h3>Payment Milestone 2 data not yet available for the engagement</h3>
      </div>
    }
  </div>
</div>
